import { createApp } from 'vue';
// import './style.css'
import router from './router.ts';
import App from './App.vue';
import GuestLayout from './components/layouts/GuestLayout.vue';
import AdminLayout from './components/layouts/AdminLayout.vue';
import { createI18n } from 'vue-i18n';
import { createPinia } from 'pinia';
import piniaPersistedState from 'pinia-plugin-persistedstate';
import locale_db from './data/localeResources.ts';
import Loader from './components/Loader.vue';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import 'sweetalert2/src/sweetalert2.scss';
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';

const app = createApp(App);
const pinia = createPinia();
pinia.use(piniaPersistedState);

if (localStorage.getItem('locale') === null) {
    localStorage.setItem('locale', 'ar');
}
const i18n = createI18n({
    locale: localStorage.getItem('locale') || 'ar',
    fallbackLocale: localStorage.getItem('locale') || 'ar',
    messages: {
        ar: locale_db.ar,
        en: locale_db.en,
    },
});
app.config.globalProperties.$localeT = function (key: string) {
    return i18n.global.t(key);
}

app.use(pinia);
app.use(i18n);
app.use(VueSweetalert2);
app.component('App', App);
app.component('app-layout', GuestLayout);
app.component('admin-layout', AdminLayout);
app.component('loading-spinner', Loader);
app.component('vue-quill', QuillEditor);

app.use(router).mount('#app');
